module.exports = __webpack_public_path__ + "img/Path 9.028aa7e9.png";